import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var PieChart = createReactComponent("PieChart", ["svg", defaultAttributes, [["path", {
  d: "M21.21 15.89A10 10 0 118 2.83",
  key: "1quz0o"
}], ["path", {
  d: "M22 12A10 10 0 0012 2v10z",
  key: "82go5e"
}]]]);
export default PieChart;